import styles from './loader.module.css';

interface LoaderProps {
  fullscreen?: boolean;
}

function Loader({ fullscreen = false }: LoaderProps) {
  if (fullscreen) {
    return (
      <div className={styles.overlay}>
        <div className={styles.loader}></div>
      </div>
    );
  }

  return <div className={styles.loader}></div>;
}

export default Loader;
